//elements: timer, hint, Intersect Intersection observer

<template>
  <v-container fluid>
    <v-data-iterator :items="questions" :search="search" hide-default-footer>
      <template v-slot:header>
        <v-toolbar floating class="justify-space-between qSearchBar">
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search Questions"
          ></v-text-field>
          <v-switch
            class="qSwitch"
            v-model="search"
            label="Marked"
            color="red darken-3"
            value="marked"
          ></v-switch>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="question in props.items"
            :key="question.number"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <!-- <v-card>
              <v-card-title class="subheading font-weight-bold">{{
                question.question
              }}</v-card-title>
            </v-card>-->
            <div>
              <question class="mt-5" :question="question" />
              <!-- <p>{{question.question}}</p> -->
            </div>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
    <v-btn rounded class="navBtn" color="warning" dark>Submit Test</v-btn>
  </v-container>
</template>

<script>
import Question from "@/components/prep/Question.vue";
import { questions } from "../data/qdata";

export default {
  data() {
    return {
      search: "",

      questions: questions
    };
  },
  components: {
    question: Question
  }
};
</script>

<style scoped>
.qSearchBar {
  position: fixed;
  z-index: 10;
  top: 5em;
  margin-right: 5%;
  opacity: 0.4;
  right: 0px;
}

.qSearchBar:hover {
  opacity: 0.9;
}

.qSwitch {
  position: relative;
  top: 0.6em;
  padding: 0.5em;
  margin: 1em;
}

.navBtn {
  position: absolute;
  margin: 30px;
  left: 55%;
}
</style>
